import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import { memo } from 'react';

import { Box, ButtonClose, Modal, ModalProps, Typography } from '@core/component';
import { Translate } from '@core/constant';
import { EActionAttribute, EFontWeight, ESize, ETypographyVariant } from '@core/type';

const ModalWhatIsVatFreeStorageContainer = ({
  onCloseModal,
  ...restProps
}: Omit<ModalProps, 'children'>) => {
  const { t } = useTranslation(Translate.common.MODAL);

  return (
    <Modal size={ESize.LG} {...restProps} onCloseModal={onCloseModal}>
      <Modal.Header>
        <Typography textAlign="center" variant={ETypographyVariant.H2}>
          {t('whatIsVatFreeStorage.title')}
        </Typography>
      </Modal.Header>
      <Modal.Body>
        <Trans
          i18nKey={`${Translate.common.MODAL}:whatIsVatFreeStorage.description`}
          components={{
            p1: <Typography marginBottom="24px" />,
            p2: <Typography marginBottom="24px" />,
            p3: <Typography marginBottom="24px" />,
            p4: <Typography />,
            strong: <Typography as={EActionAttribute.SPAN} fontWeight={EFontWeight.BOLD} />,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Box textAlign="center">
          <ButtonClose onClick={onCloseModal} />
        </Box>
      </Modal.Footer>
    </Modal>
  );
};

export const ModalWhatIsVatFreeStorage = memo(ModalWhatIsVatFreeStorageContainer);
